import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import styles from '../../../styles/common/IndustryFeatures.module.css';
import { IndustryFeaturesdata } from "@/constants/common";
import { Autoplay, FreeMode, Mousewheel, Pagination } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/react';
const Lottie = dynamic(() => import("lottie-react"), { ssr: false });
const IndustryFeatures = () => {
  const router = useRouter();
  const data = IndustryFeaturesdata
  const [animations, setAnimations] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const isLandingPage = router.asPath === '/landing-page';
  useEffect(() => {
    // Fetch all Lottie animations
    const fetchAnimations = async () => {
      const animationPromises = data.map((item) =>
        fetch(item.lottieImg)
          .then((response) => response.json())
          .catch((error) => {
            console.error(`Error fetching animation for ${item.title}:`, error);
            return null;
          })
      );

      const animationData = await Promise.all(animationPromises);
      const animationMap = data.reduce((acc, item, index) => {
        acc[index] = animationData[index];
        return acc;
      }, {});

      setAnimations(animationMap);
    };

    fetchAnimations();
  }, []);
  useEffect(() => {

    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
      setIsLargeScreen(window.innerWidth >= 1810);
    };
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>{isMobile ?
      <div
        style={{
          display: 'grid',
          flexWrap: "wrap",
          gap: "2rem",
          margin: "5rem 0 3rem 0",
          gridTemplateColumns: "1fr",
        }}
      >
        {data.map((item, index) => (
          <div
            key={index}
            style={{
              backgroundColor: item.bgcol,
              borderRadius: "1.5rem",
              padding: "3rem",
              flex: "1 1 calc(20% - 20px)",
              position: 'relative',
              height: "32rem",
              overflow: 'hidden'

            }}
          >
            <h2 style={{ color: item.titlecol, marginBottom: "1rem", fontSize: "2rem", fontFamily: isLandingPage ? "bicyclette" : "GilroySemiBold", height: "4.5rem", fontWeight: isLandingPage ? 700 : 600, fontStyle: "normal" }}>{item.title}</h2>
            <p style={{ color: "#555", fontSize: "1.7rem", fontFamily: "GilroyMedium" }}>{item.text}</p>
            <div style={{ width:item?.width, height: item?.height, position: 'absolute', left: item?.left, bottom: item?.bottom }}>
              {/* <Lottie animationData={animations[index]} loop={true} style={{ width: "100%", height: "100%" }} /> */}
              <Lottie
                animationData={animations[index]}
                loop={true}
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          </div>
        ))}
      </div>  : 
      
      isLargeScreen ?
      
      <div style={{ 
        padding: "1.2rem", 
        margin: "0",
        display: 'flex',
        gap: '1.8rem',
        // overflowX: 'auto',
        // scrollbarWidth: 'none',
        // msOverflowStyle: 'none'
      }}>
        {/* <style jsx>{`
          div::-webkit-scrollbar {
            display: none;
          }
        `}</style> */}
        {data.map((item, index) => (
          <div
            key={index}
            style={{
              width: "29.5rem",
              flexShrink: 0
            }}
          >
            <div
              style={{
                backgroundColor: item.bgcol,
                borderRadius: "1.5rem",
                position: 'relative',
                height: "32rem",
                padding: "3rem",
                overflow: 'hidden',
                width: '100%'
              }}
            >
              <h2 style={{ color: item.titlecol, marginBottom: "1rem", fontSize: "2rem", fontFamily: isLandingPage ? "bicyclette" : "GilroySemiBold", height: "4.5rem", fontWeight: isLandingPage ? 700 : 600, fontStyle: "normal" }}>{item.title}</h2>
              <p style={{ color: "#555", fontFamily: "GilroyMedium", fontSize: "1.4rem" }}>{item.text}</p>
              <div style={{ width:item?.width, height: item?.height, position: 'absolute', left: item?.left, bottom: item?.bottom }}>
                <Lottie
                  animationData={animations[index]}
                  loop={true}
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      :


       <div style={{ padding: "1.2rem", margin: "0", minHeight: "36rem" }}>
        <Swiper
          spaceBetween={30}
          slidesPerView={'auto'}
          autoplay={{
            delay: 10000,
            disableOnInteraction: false,
          }}
          speed={1000}
          pagination={{ clickable: true }}
          modules={[Autoplay, Pagination, Mousewheel, FreeMode]}
          className="custom-features-swiper"
          freeMode={true}
          mousewheel={{
            forceToAxis: true,
            invert: false,
            sensitivity: 1,
          }}
          grabCursor={true}
        >
          {data.map((item, index) => (
            <SwiperSlide
              key={index}
              style={{
                width: "29rem",
              }}
            >
              <div
                style={{
                  backgroundColor: item.bgcol,
                  borderRadius: "1.5rem",
                  position: 'relative',
                  height: "32rem",
                  padding: "3rem",
                  overflow: 'hidden',
                  width: '100%'
                }}
              >
                <h2 style={{ color: item.titlecol, marginBottom: "1rem", fontSize: "2rem", fontFamily: isLandingPage ? "bicyclette" : "GilroySemiBold", height: "4.5rem", fontWeight: isLandingPage ? 700 : 600, fontStyle: "normal" }}>{item.title}</h2>
                <p style={{ color: "#555", fontFamily: "GilroyMedium", fontSize: "1.4rem" }}>{item.text}</p>
                <div style={{width:item?.width, height: item?.height, position: 'absolute', left: item?.left, bottom: item?.bottom }}>
                  <Lottie
                    animationData={animations[index]}
                    loop={true}
                    style={{ width: "100%", height: "100%" }}
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>


    }
    </>

  );
};

export default IndustryFeatures;
